import WebRTCIssueDetector, {
  AvailableOutgoingBitrateIssueDetector,
  InboundNetworkIssueDetector,
  FrozenVideoTrackDetector,
  QualityLimitationsIssueDetector,
  OutboundNetworkIssueDetector,
  NetworkMediaSyncIssueDetector,
  VideoDecoderIssueDetector,
  MosQuality,
} from 'webrtc-issue-detector';
import { QOS_STATS_INTERVAL } from '../constants';

let instance: WebRTCIssueDetector | null = null;

// It can not be instantiated as constant because it requires window to be defined and it is not available in the server side.
// It also should be a singleton because monkey patching RTCPeerConnection doesn't work if it is instantiated multiple times.
export const getIssueDetector = () => {
  if (!instance) {
    instance = new WebRTCIssueDetector({
      getStatsInterval: QOS_STATS_INTERVAL,
      detectors: [
        new FrozenVideoTrackDetector({
          avgFreezeDurationThresholdMs: 500, // Report issue if average freeze > 500ms instead of default 1000ms
          minMosQuality: MosQuality.FAIR, // Report issue if MOS quality is above fair
        }),
        new VideoDecoderIssueDetector({
          volatilityThreshold: 20, // Trigger if fps changes >20%
          minMosQuality: MosQuality.FAIR, // Report issue if MOS quality is above fair
        }),
        new QualityLimitationsIssueDetector(),
        new InboundNetworkIssueDetector({
          highPacketLossThresholdPct: 4, // Trigger if packet loss >4% (visible degradation) It's aligned with Vonage doc https://tokbox.com/developer/tools/inspector_doc/#quality-metrics
          highRttThresholdMs: 300, // Trigger if round-trip time >300ms (noticeable delay) It's aligned with Vonage doc https://tokbox.com/developer/tools/inspector_doc/#quality-metrics
          highJitterThreshold: 0.05, // Trigger if jitter >50ms (impacts smoothness)
          highJitterBufferDelayThresholdMs: 200, // Trigger if jitter buffer delay >200ms
        }),
        new OutboundNetworkIssueDetector({
          highPacketLossThresholdPct: 4, // Trigger if packet loss >4% (visible degradation) It's aligned with Vonage doc https://tokbox.com/developer/tools/inspector_doc/#quality-metrics
          highJitterThreshold: 0.05, // Trigger if jitter >50ms (impacts smoothness)
        }),
        new NetworkMediaSyncIssueDetector({
          correctedSamplesThresholdPct: 4, // Trigger if corrected samples >4% (impacts smoothness)
        }),
        new AvailableOutgoingBitrateIssueDetector({
          availableOutgoingBitrateThreshold: 300_000, // Trigger if available outgoing bitrate <300kbps. It's align with Vonage Inspector threshold
        }),
      ],
    });
  }

  return instance;
};
